import { render, staticRenderFns } from "./sDataBank.vue?vue&type=template&id=208c511e"
import script from "./sDataBank.vue?vue&type=script&lang=js"
export * from "./sDataBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports